import React, { useEffect, useRef, useState, useCallback} from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import './qrcodescan.css';
import { isMobile } from "react-device-detect";
import { useFetch } from "../api/FetchApiData";
import { FaCheckCircle } from "react-icons/fa";
import { MediaUrl } from './Media';


function base64urlToBuffer(base64url){
    base64url = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = (base64url.length % 4);
    if (padding) {
      base64url += '='.repeat(4-padding);
    } 
    const binary = window.atob(base64url);
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return buffer;
  }

function bufferToBase64url(buffer) {
  return btoa(
    String.fromCharCode(...new Uint8Array(buffer))
  )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function QrCustomerTicket ({close, style={width:'100%'} })
{  
    const QrCodeReaderRef = useRef(null);
    const fetchData = useFetch();
    const [qrState,setQrState] = useState("QrCode");
    const [order,setOrder] = useState(null);
    const [signAuth,setSignAuth] = useState(null); 
    const [payment_mount,setPaymentMount] = useState(0);
    const [notification,setNotification] = useState({text:'',color:'black',display:'none'});
    const [comment, setComment] = useState('');

    const onScan = useCallback(async (data)=>{
        const data_ = {meta:'qrcode',ticket:data,type:'costumer_ticket'}
        fetchData.PostData(data_,'qr_code/').then((result)=>{
          console.log(result);  
          if(result.result)
            {
                setOrder(result.order);
                setPaymentMount(result.order.payment_status.remained?Number(result.order.payment_status.remained):0);
                setSignAuth(result.auth);
            }
            else
            {
                setNotification({text:result.error,display:'block',color:'orangered'});
            }
        });
    },[fetchData])

    const send_payment= async ()=>{
        let webauthnProof = null;
        const assertion = await navigator.credentials.get({
              publicKey: {
                challenge: base64urlToBuffer(signAuth.challenge),
                allowCredentials: signAuth.allowCredentials.map(cred => ({
                  id: base64urlToBuffer(cred.id),
                  type: cred.type})),
                rpId: signAuth.rpId,
                userVerification: signAuth.userVerification
              }});          
        webauthnProof = {
              id: bufferToBase64url(assertion.rawId),
              rawId: bufferToBase64url(assertion.rawId),
              type: assertion.type,
              response: {
                authenticatorData: bufferToBase64url(assertion.response.authenticatorData),
                clientDataJSON: bufferToBase64url(assertion.response.clientDataJSON),
                signature: bufferToBase64url(assertion.response.signature),
                userHandle: assertion.response.userHandle
                  ? bufferToBase64url(assertion.response.userHandle)
                  : null
              }
            };
        const data_ = {meta:'payment',customer_ticket:order.customer_ticket,mount:payment_mount,type:'costumer_ticket',comment:comment,auth:webauthnProof}
        fetchData.PutData(data_,'sales/payment/').then((result)=>{
            if(result.result)
            {
                setQrState("QrEnd");
                setNotification({text:<div><label style={{fontSize:'small',verticalAlign:'middle'}}>Paiement enregistré avec succès</label><FaCheckCircle size={20} style={{verticalAlign:'middle',marginLeft:'10px'}}  color="green" /></div>,
                color:'black',
                display:'block'
              });
            }
            else
            {
               setNotification({text:result.error, color:'orangered', display:'block'});
            }
        });
    }

    useEffect(()=> {
      if(!!order)
      {
          setQrState("Order");
          if(order.payment_status.status !== 'payment_completed')
          {
            const jsx_ = <div style={{fontSize:'xx-small'}}><input style={{marginRight:'15px'}} onChange={e=>{}} type="checkbox" checked={false} /><label>J'atteste que la somme indiqué ci-dessous n'a été remis en main propre</label></div>
            setNotification({text:jsx_,display:'block',color:'black'});
          }
          else{
            const jsx_ = <div style={{fontSize:'xx-small'}}><input style={{marginRight:'15px'}} onChange={e=>{}} type="checkbox" checked={false} /><label>J'atteste que j'ai remis le colis au client en main propre</label></div>
            setNotification({text:jsx_,display:'block',color:'black'});
          }
      }
    }, [order]);

    useEffect(() => {
      try{
    const scanner = new Html5QrcodeScanner("qr-reader-customer", {
      fps: 10,
      qrbox: 250,
    });

    scanner.render(
      (decodedText) => {
        console.log(decodedText);
        onScan(decodedText);
        scanner.clear();
      },
      (error) => {}
    );
    
    return () => {
      scanner.clear();
    };
    }
    catch(e){console.log(e);}
      }, [onScan]);

  let _style = {width:'50%',top:'0px'};
  if(isMobile)
    _style = {width:'90%',margin:'auto',top:'0px'};


  return (
          <div className="qr-code-content" style={_style}>
            {(qrState === "QrCode") && <>
                  <div id="qr-reader-customer" ref={QrCodeReaderRef} style={{margin:'auto',border:'none'}} />
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
            </>}
            {(qrState === "Order") && <>
                  <div style={{fontSize:'small',marginTop:'15px'}}>
                    <h3 style={{fontSize:'medium'}}>Commande Trouvée <FaCheckCircle size={20} color="green" /></h3>
                    <label className="qr-label">N ° : {order.order_number}</label><br/>
                    <label className="qr-label">Client : {order.customer.label} </label><br/>
                    <label className="qr-label">Status : <span style={{fontWeight:'bold'}}>{order.status.status.toUpperCase()}</span></label><br/>
                    <label className="qr-label">Reste Dûe : <span style={{fontWeight:'bold',color:order.payment_status.color}}>{order.payment_status.remained}</span></label><br/>
                    <label className="qr-label">Colis Reçu : {order.partner_order_received}</label><br/>
                  </div>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
                  {(order.payment_status.status !== 'payment_completed') &&
                      <div style={{width:'100%'}}>
                        <input onChange={e=>{setPaymentMount(e.target.value)}} type="number" min={order.payment_status.min} max={order.payment_status.max} defaultValue={order.payment_status.remained} className="qr-input-payment" />
                        <label style={{textAlign:'left',marginLeft:'10px'}}>Euros </label>
                        <input onChange={e=>{setComment(e.target.value)}} style={{color:'gray',width:'100%'}} type="texterea"  placeholder="Ajouter un commentaire" className="qr-input-payment" />
                      </div>    
                  }
                  <input onClick={e=>{send_payment()}} disabled={(order.payment_status.status === 'payment_completed') && (!order.partner_received)} type="button" value={'Valider'} className="qr-validate-btn" />
            </>}
            {(qrState === "QrEnd") && <>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
            </>}
            <input onClick={e=>{close();}} type="button" value={'Annuler'} className="qr-code-btn" />
            <div>
              <span style={{fontSize:'x-small',fontStyle:'italic'}}>(i) Veuillez scanner un QR-Code d'un client a fin de proceder à un paiement en cash</span>
            </div>
          </div>)
}

export function QrPaymentTicket ({close, style={width:'100%'} })
{  
    const QrCodeReaderRef = useRef(null);
    const fetchData = useFetch();
    const [qrState,setQrState] = useState("QrCode");
    const [payment,setPayment] = useState(null);
    const [signAuth,setSignAuth] = useState(null); 
    const [notification,setNotification] = useState({text:'',color:'black',display:'none'});
    const [comment, setComment] = useState('');

    const onScan = useCallback(async (data)=>{
        fetchData.PostData({meta:'qrcode',ticket:data,type:'payment_ticket'},'qr_code/').then((result)=>{
            console.log(result);
            if(result.result)
            {
                setNotification({text:"Vous pouvez recupérer l'argent", color:'green', display:'block'});
                setPayment(result.payment);
                setSignAuth(result.auth);
            }
            else
            {
                setNotification({text:result.error, color:'orangered', display:'block'});
            }
        });
    },[fetchData])

    const pick_payment= async ()=>{
        let webauthnProof = null;
        const assertion = await navigator.credentials.get({
              publicKey: {
                challenge: base64urlToBuffer(signAuth.challenge),
                allowCredentials: signAuth.allowCredentials.map(cred => ({
                  id: base64urlToBuffer(cred.id),
                  type: cred.type})),
                rpId: signAuth.rpId,
                userVerification: signAuth.userVerification
              }
        });
            
        webauthnProof = {
              id: bufferToBase64url(assertion.rawId),
              rawId: bufferToBase64url(assertion.rawId),
              type: assertion.type,
              response: {
                authenticatorData: bufferToBase64url(assertion.response.authenticatorData),
                clientDataJSON: bufferToBase64url(assertion.response.clientDataJSON),
                signature: bufferToBase64url(assertion.response.signature),
                userHandle: assertion.response.userHandle
                  ? bufferToBase64url(assertion.response.userHandle)
                  : null
              }
        };
        const data_ = {action:'agent',type:'payment_ticket',comment:comment,auth:webauthnProof};
        fetchData.PutData(data_,'user/payment/').then((result)=>{
            console.log(result);
            if(result.result)
            {
                setQrState("QrEnd");
                setNotification({text:<div><label style={{fontSize:'small',verticalAlign:'middle'}}>Paiement recupéré avec succès</label><FaCheckCircle size={20} style={{verticalAlign:'middle',marginLeft:'10px'}}  color="green" /></div>,
                color:'black',
                display:'block'
              });
            }
            else
            {
              setNotification({text:result.error, color:'orangered', display:'block'});
            }
        });


    }

    useEffect(()=> {
      if(!!payment)
      {
          setQrState("Payment");
          const jsx_ = <div style={{fontSize:'xx-small'}}><input style={{marginRight:'15px'}} onChange={e=>{}} type="checkbox" checked={false} /><label>J'atteste que la somme indiqué ci-dessous n'a été remis en main propre</label></div>
          setNotification({text:jsx_,display:'block',color:'black'});

      }
    }, [payment]);

    useEffect(() => {
      try{
    const scanner = new Html5QrcodeScanner("qr-reader-payment", {
      fps: 10,
      qrbox: 250,
    });
    scanner.render(
      (decodedText) => {
        onScan(decodedText);
        scanner.clear();
      },
      (error) => {}
    );
    return () => {
      scanner.clear();
    };
    }
    catch(e){console.log(e);}
      }, [onScan]);

  let _style = {width:'50%',top:'0px'};
  if(isMobile)
    _style = {width:'90%',margin:'auto',top:'0px'};


  return (
          <div className="qr-code-content" style={_style}>
            {(qrState === "QrCode") && 
            <>
                  <div id="qr-reader-payment" ref={QrCodeReaderRef} style={{margin:'auto',border:'none'}} />
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
                  <div>
                    <span style={{fontSize:'x-small',fontStyle:'italic'}}>(i) Veuillez scanner le QR-Code d'un paiement a fin de le récupérer</span>
                </div>
            </>}
            {(qrState === "Payment") && <>
                  <div style={{fontSize:'small',marginTop:'15px'}}>
                    <h3 style={{fontSize:'medium'}}>Paiement Trouvé <FaCheckCircle size={20} color="green" /></h3>
                    <label className="qr-label">Commande : {payment.order.order_number}</label><br/>
                    <label className="qr-label">Agent : {payment.agent.label_name} </label><br/>
                    <label className="qr-label">Contact : {payment.agent.phone} </label><br/>
                    <label className="qr-label">Reference : {payment.id}</label><br/>
                    <label className="qr-label">Sommme : <span style={{fontWeight:'bold',color:'black'}}>{payment.mount} Euros</span></label><br/>
                  </div>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
                  <input onClick={e=>{pick_payment()}}  type="button" value={'Récupérer'} className="qr-validate-btn" />
            </>}
            {(qrState === "QrEnd") && <>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
            </>}
            <input onClick={e=>{close();}} type="button" value={'Annuler'} className="qr-code-btn" />

          </div>)
}

export function QrPackageTicket ({close, style={width:'100%'} })
{   
    const QrCodeReaderRef = useRef(null);
    const fetchData = useFetch();
    const [qrState,setQrState] = useState("QrCode");
    const [order,setOrder] = useState(null);
    const [signAuth,setSignAuth] = useState(null); 
    const [notification,setNotification] = useState({text:'',color:'black',display:'none'});
    const [comment, setComment] = useState('');

    const onScan = useCallback(async (data)=>{
        const data_ = {meta:'qrcode',ticket:data,type:'package_ticket'}
        fetchData.PostData(data_,'qr_code/').then((result)=>{
            console.log(result);
            if(result.result)
            {
                setOrder(result.order);
                if(!!result.auth)
                  setSignAuth(result.auth);
            }
            else
            {
                setNotification({text:result.error,display:'block',color:'orangered'});
            }
        });
    },[fetchData])

    const pick_up_package= async ()=>{
        let webauthnProof = null;
        if(!!signAuth)
        {
          const assertion = await navigator.credentials.get({
                publicKey: {
                  challenge: base64urlToBuffer(signAuth.challenge),
                  allowCredentials: signAuth.allowCredentials.map(cred => ({
                    id: base64urlToBuffer(cred.id),
                    type: cred.type})),
                  rpId: signAuth.rpId,
                  userVerification: signAuth.userVerification
                }
              });    
          webauthnProof = {
                      id: bufferToBase64url(assertion.rawId),
                      rawId: bufferToBase64url(assertion.rawId),
                      type: assertion.type,
                      response: {
                        authenticatorData: bufferToBase64url(assertion.response.authenticatorData),
                        clientDataJSON: bufferToBase64url(assertion.response.clientDataJSON),
                        signature: bufferToBase64url(assertion.response.signature),
                        userHandle: assertion.response.userHandle
                          ? bufferToBase64url(assertion.response.userHandle)
                          : null
                      }
                    };
        }
        //console.log(webauthnProof);
        const data_ = {meta:'package',comment:comment,auth:webauthnProof}
        fetchData.PostData(data_,'order_article/').then((result)=>{
            console.log(result);
            if(result.result)
            {
               setQrState("QrEnd");
               setNotification({text:<label style={{fontSize:'small'}}>Colis recupéré avec succès <FaCheckCircle size={20} color="green" /></label>,
                color:'black',
                display:'block'
              });
            }
            else
            {
                setNotification({text:result.error,
                color:'black',
                display:'block'
              });
            }
        });
    }

    useEffect(()=> {
      if(!!order)
      {
        setQrState("Order");
        const jsx_ = <div style={{fontSize:'xx-small'}}><input style={{marginRight:'15px'}} onChange={e=>{}} type="checkbox" checked={false} /><label>J'atteste que j'ai récupéré le colis identifié ci-dessus</label></div>
        setNotification({text:jsx_,display:'block',color:'black'});      
      }
    }, [order]);  

    useEffect(() => {
      try{
    const scanner = new Html5QrcodeScanner("qr-reader-package", {
      fps: 10,
      qrbox: 250,
    });

    scanner.render(
      (decodedText) => {
        console.log(decodedText);
        onScan(decodedText);
        scanner.clear();
      },
      (error) => {}
    );
    
    return () => {
      scanner.clear();
    };
    }
    catch(e){console.log(e);}
      }, [onScan]);

  let _style = {width:'50%',top:'0px'};
  if(isMobile)
    _style = {width:'90%',margin:'auto',top:'0px'};


  return (
          <div className="qr-code-content" style={_style}>
            {(qrState === "QrCode") && <>
                  <div id="qr-reader-package" ref={QrCodeReaderRef} style={{margin:'auto',border:'none'}} />
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
            </>}
            {(qrState === "Order") && <>
                  <div style={{fontSize:'small',marginTop:'15px'}}>
                    <h3 style={{fontSize:'medium'}}>{order.title} <FaCheckCircle size={20} color="green" /></h3>
                    <label className="qr-label">Ref : {order.id}</label><br/>
                    <label className="qr-label">Client : {order.client.label_name} </label><br/>
                    <label className="qr-label">Date : <span style={{fontWeight:'bold'}}>{order.delivery_date}</span></label><br/>
                    <label className="qr-label">Add Livraison : <span style={{}}>{order.address.display_name}</span></label><br/>
                  </div>
                  <div style={{width:'100%'}}>
                    <input onChange={e=>{setComment(e.target.value)}} style={{color:'gray',fontSize:'x-small'}} type="texterea"  placeholder="Ajouter un commentaire" className="qr-input-payment" />
                  </div>
                  <div style={{width:'100%'}}>
                      {
                        order.package_images.map((image,index) => {
                          console.log(image);
                          return( <img src={MediaUrl(image.image)} style={{width:'100px'}} key={index} />)
                        })
                      }
                    </div>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
                  <input onClick={e=>{pick_up_package()}} type="button" value={'Récupérer'} className="qr-validate-btn" />
            </>}
            {(qrState === "QrEnd") && <>
                  <label style={{display:'block',margin:'10px',color:notification.color}}>
                    {notification.text}
                  </label>
            </>}
            { (qrState=== "QrEnd") ? <input onClick={e=>{close();}} type="button" value={'Fermer'} className="qr-code-btn" />:
                 <input onClick={e=>{close();}} type="button" value={'Annuler'} className="qr-code-btn" />
            }
            <div>
              <span style={{fontSize:'x-small',fontStyle:'italic'}}>(i) Veuillez scanner un QR-Code pour récupéerer un colis</span>
            </div>
          </div>)
}


export function QRScanner({ onScan, close,notification = "", style={width:'100%'} }) 
{  
    const QrCodeReaderRef = useRef(<div id="qr-reader" style={{margin:'auto',border:'none'}} />);
    useEffect(() => {
      try{
    const scanner = new Html5QrcodeScanner("qr-reader", {
      fps: 10,
      qrbox: 250,
    });

    scanner.render(
      (decodedText) => {
        onScan(decodedText);
        scanner.clear();
      },
      (error) => {}
    );
    
    return () => {
      scanner.clear();
    };
    }
    catch{}
  }, [onScan]);

  let _style = {width:'50%'};
  if(isMobile)
    _style = {width:'90%',margin:'auto'};
  return (
      <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
          <div className="qr-code-content" style={_style}>
            {QrCodeReaderRef.current}
            <label style={{display:'block',margin:'10px',color:'gray'}}>
              {notification}
            </label>
            <input onClick={e=>{close();}} type="button" value={'Annuler'} className="qr-code-btn" />
          </div>
      </div>)
}
